(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-hero-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function HeroSlider(root) {
      this.root = root;
      this.viewport = root.querySelector('.cs-hero-slider__viewport');
      this.track = root.querySelector('.cs-hero-slider__track');
      this.originalSlides = Array.prototype.slice.call(root.querySelectorAll('.cs-hero-slider__slide'));
      this.prevBtn = root.querySelector('.cs-hero-slider__arrow--prev');
      this.nextBtn = root.querySelector('.cs-hero-slider__arrow--next');

      if (!this.viewport || !this.track || this.originalSlides.length === 0) return;

      this.totalOriginal = this.originalSlides.length;
      this.autoplay = this.viewport.dataset.autoplay === 'true';
      this.autoplaySpeed = parseInt(this.viewport.dataset.autoplaySpeed, 10) || 4000;
      this.autoplayTimer = null;
      this.isTransitioning = false;

      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;
      this.dragOffset = 0;
      this.dragStartTime = 0;

      this.init();
    }

    HeroSlider.prototype.init = function () {
      var self = this;

      if (this.totalOriginal <= 1) return;

      this.cloneSlides();
      this.currentIndex = this.totalOriginal;
      this.update(false);

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.next(-1);
        });
      }
      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          self.next(1);
        });
      }

      this.track.addEventListener('transitionend', function () {
        self.handleTransitionEnd();
      });

      // ===== TOUCH (mobile/tablette) - VERSION ULTRA-SIMPLE =====
      // On ne suit PAS le doigt en temps réel (pas de touchmove) pour ne
      // PAS interférer avec les clics natifs sur les flèches.
      // On capture juste le X au début et le X à la fin pour détecter le swipe.
      this.track.addEventListener('touchstart', this.onTouchStart.bind(this), { passive: true });
      this.track.addEventListener('touchend', this.onTouchEnd.bind(this), { passive: true });
      this.track.addEventListener('touchcancel', this.onTouchEnd.bind(this), { passive: true });

      // ===== SOURIS (desktop uniquement) =====
      this.track.addEventListener('mousedown', this.onMouseDown.bind(this));
      this._boundMouseMove = this.onMouseMove.bind(this);
      this._boundMouseUp = this.onMouseUp.bind(this);

      this.track.querySelectorAll('img').forEach(function (img) {
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });

      this.root.addEventListener('mouseenter', this.stopAutoplay.bind(this));
      this.root.addEventListener('mouseleave', this.startAutoplay.bind(this));

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) self.stopAutoplay();
        else self.startAutoplay();
      });

      this.resizeTimeout = null;
      window.addEventListener('resize', function () {
        clearTimeout(self.resizeTimeout);
        self.resizeTimeout = setTimeout(function () { self.update(false); }, 100);
      });

      this.startAutoplay();
    };

    HeroSlider.prototype.cloneSlides = function () {
      var self = this;
      this.originalSlides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('cs-hero-slider__slide--clone');
        self.track.insertBefore(clone, self.track.firstChild);
      });
      this.originalSlides.forEach(function (slide) {
        var clone = slide.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('cs-hero-slider__slide--clone');
        self.track.appendChild(clone);
      });

      this.track.querySelectorAll('.cs-hero-slider__slide--clone img').forEach(function (img) {
        img.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });

      this.allSlides = Array.prototype.slice.call(this.track.querySelectorAll('.cs-hero-slider__slide'));
    };

    HeroSlider.prototype.next = function (direction) {
      // Sécurité : si on est resté dans un état drag bloqué, on reset proprement
      if (this.isDragging) {
        this.isDragging = false;
        this.dragOffset = 0;
        this.dragDirection = null;
        this.track.style.transition = '';
      }
      if (this.isTransitioning) return;
      this.currentIndex += direction;
      this.update(true);
      this.restartAutoplay();
    };

    HeroSlider.prototype.update = function (animate) {
      if (!this.allSlides || this.allSlides.length === 0) return;

      if (animate) {
        this.track.style.transition = '';
        this.isTransitioning = true;
      } else {
        this.track.style.transition = 'none';
      }

      var slideWidth = this.allSlides[0].getBoundingClientRect().width;
      var offset = -(this.currentIndex * slideWidth);
      this.track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';

      if (!animate) {
        var _ = this.track.offsetHeight;
        this.track.style.transition = '';
      }
    };

    HeroSlider.prototype.handleTransitionEnd = function () {
      this.isTransitioning = false;

      if (this.currentIndex >= this.totalOriginal * 2) {
        this.currentIndex = this.totalOriginal;
        this.update(false);
      } else if (this.currentIndex < this.totalOriginal) {
        this.currentIndex = this.currentIndex + this.totalOriginal;
        this.update(false);
      }
    };

    HeroSlider.prototype.startAutoplay = function () {
      if (!this.autoplay || this.totalOriginal <= 1) return;
      var self = this;
      this.stopAutoplay();
      this.autoplayTimer = setInterval(function () { self.next(1); }, this.autoplaySpeed);
    };

    HeroSlider.prototype.stopAutoplay = function () {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    };

    HeroSlider.prototype.restartAutoplay = function () {
      this.stopAutoplay();
      this.startAutoplay();
    };

    // ===================================================================
    // LOGIQUE TACTILE (TOUCH) - mobile et tablette
    // VERSION ULTRA-SIMPLE : on ne suit PAS le doigt en temps réel.
    // On capture juste le X de départ et le X de fin pour détecter un swipe.
    // Cela évite d'interférer avec les clics natifs sur les flèches.
    // ===================================================================

    HeroSlider.prototype.onTouchStart = function (e) {
      if (this.isTransitioning) return;
      if (!e.touches || e.touches.length === 0) return;

      this.touchStartX = e.touches[0].clientX;
      this.touchStartY = e.touches[0].clientY;
      this.touchStartTime = Date.now();
      this.stopAutoplay();
    };

    HeroSlider.prototype.onTouchEnd = function (e) {
      // Récupère la position finale (changedTouches contient la dernière position)
      if (!e.changedTouches || e.changedTouches.length === 0) {
        this.startAutoplay();
        return;
      }

      var endX = e.changedTouches[0].clientX;
      var endY = e.changedTouches[0].clientY;
      var deltaX = endX - this.touchStartX;
      var deltaY = endY - this.touchStartY;
      var duration = Date.now() - this.touchStartTime;

      // Vérifier que c'est bien un swipe horizontal et pas vertical
      // - Mouvement horizontal supérieur au vertical
      // - Mouvement minimum de 50px (sinon c'est un tap)
      // - Mouvement maximum de 1 seconde (sinon c'est un drag long)
      if (Math.abs(deltaX) > Math.abs(deltaY) &&
          Math.abs(deltaX) > 50 &&
          duration < 1000) {
        if (deltaX < 0) {
          this.next(1); // swipe vers la gauche -> slide suivant
        } else {
          this.next(-1); // swipe vers la droite -> slide précédent
        }
      }

      this.startAutoplay();
    };

    // ===================================================================
    // LOGIQUE SOURIS (MOUSE) - desktop uniquement
    // ===================================================================

    HeroSlider.prototype.onMouseDown = function (e) {
      if (this.isTransitioning) return;
      // Ignorer si c'est un clic droit ou clic molette
      if (e.button !== undefined && e.button !== 0) return;

      this.isDragging = true;
      this.startX = e.clientX;
      this.dragStartTime = Date.now();
      this.dragOffset = 0;
      this.track.style.transition = 'none';
      this.stopAutoplay();

      // On attache les listeners souris UNIQUEMENT pendant le drag
      document.addEventListener('mousemove', this._boundMouseMove);
      document.addEventListener('mouseup', this._boundMouseUp);

      // Empêcher la sélection de texte pendant le drag
      e.preventDefault();
    };

    HeroSlider.prototype.onMouseMove = function (e) {
      if (!this.isDragging) return;
      this.dragOffset = e.clientX - this.startX;
      var slideWidth = this.allSlides[0].getBoundingClientRect().width;
      var baseOffset = -(this.currentIndex * slideWidth);
      this.track.style.transform = 'translate3d(' + (baseOffset + this.dragOffset) + 'px, 0, 0)';
    };

    HeroSlider.prototype.onMouseUp = function () {
      // Toujours retirer les listeners souris, même si pas de drag actif
      document.removeEventListener('mousemove', this._boundMouseMove);
      document.removeEventListener('mouseup', this._boundMouseUp);

      if (!this.isDragging) return;
      this.isDragging = false;
      this.track.style.transition = '';

      var threshold = 50;
      var dragDuration = Date.now() - this.dragStartTime;
      var velocity = Math.abs(this.dragOffset) / dragDuration;

      if (this.dragOffset < -threshold || (velocity > 0.3 && this.dragOffset < -10)) {
        this.next(1);
      } else if (this.dragOffset > threshold || (velocity > 0.3 && this.dragOffset > 10)) {
        this.next(-1);
      } else {
        this.update(true);
      }
      this.dragOffset = 0;
      this.startAutoplay();
    };

    function initAll() {
      var sliders = document.querySelectorAll('.cs-hero-slider');
      sliders.forEach(function (slider) {
        if (slider.dataset.initialized === 'true') return;
        new HeroSlider(slider);
        slider.dataset.initialized = 'true';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.cs-hero-slider');
      if (section) {
        section.dataset.initialized = 'false';
        new HeroSlider(section);
        section.dataset.initialized = 'true';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["diagnostic-capillaire"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Les liens Olvio fonctionnent par hash : un hash identique ne redeclenche
    // pas l'ouverture. On le reinitialise avant de le reappliquer.
    document.addEventListener('click', function (e) {
      var link = e.target.closest('[data-chs-diag-link]');
      if (!link) { return; }

      var href = link.getAttribute('href') || '';
      if (href.indexOf('#olvio_advisor=') !== 0) { return; }

      if (window.location.hash === href) {
        e.preventDefault();
        history.replaceState(null, '', window.location.pathname + window.location.search);
        window.location.hash = href.slice(1);
      }
    });

    // Arrivee depuis le chat Olvio : on place le curseur sur le telephone.
    if (window.location.hash === '#chs-diag-form') {
      window.setTimeout(function () {
        var phone = document.getElementById('chs-diag-phone');
        if (phone) { phone.focus({ preventScroll: true }); }
      }, 400);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
